import { Component, Input, OnInit } from '@angular/core';
import { UserData } from 'src/app/class/datatype';
import { AuthService } from 'src/app/services/auth/auth.service';
import { StudentService } from 'src/app/services/student/student.service';
import { StudentData } from 'src/app/class/datatype';
import { ToastrService } from 'ngx-toastr';
import { ErrorhandlerService } from 'src/app/services/errorhandler/errorhandler.service';
import { interval } from 'rxjs';
import { ThemeService, ThemeMode } from 'src/app/services/theme/theme.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  styleUrls: ['./app-header.component.scss'],
  templateUrl: './app-header.component.html',
})
export class AppHeaderComponent implements OnInit {
  /** Layout tanpa sidebar (layar kasir) menyembunyikan tombol hamburger/sidebar. */
  @Input() showSidebarToggles = true;
  isProd = environment.production;
  public user: UserData;
  public retentionData: StudentData;

  constructor(
    private auth: AuthService,
    public Student: StudentService,
    private toastr: ToastrService,
    private eHandler: ErrorhandlerService,
    public themeService: ThemeService
  ) {}

  setTheme(mode: ThemeMode) {
    this.themeService.setMode(mode);
  }

  getRetentionData() {
    this.Student.getMemberRetentionData().subscribe({
      next: (data) => {
        if (data.data.length > 0) {
          data.data.forEach((data, index) => {
            this.toastr.info(`Member atas nama ${data.name} telah melakukan perpanjangan ke ${data.is_retention}`, 'Informasi Member Perpanjangan');
          });
        }
      },
      error: (err) => {
        this.eHandler.errorHttp(err);
      },
    });
  }

  interval = interval(20000).subscribe((val) => {
    if (this.user.username == 'accounting') {
      this.getRetentionData();
    }
  });

  ngOnInit() {
    this.user = this.auth.user;
    if (this.user.username == 'accounting') {
      this.getRetentionData();
    }
  }
}
